import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";

import { updatePickZone } from "@/api/pick-zones-api";
import { type PickZoneConfiguration } from "@/schemas";

import { PICK_ZONES_QUERY_KEY } from "./use-pick-zones";

export const useUpdatePickZone = () => {
	const intl = useIntl();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ pickZoneId, data }: { pickZoneId: string; data: PickZoneConfiguration }) => {
			await updatePickZone(pickZoneId, data, intl);

			await queryClient.refetchQueries({ queryKey: [PICK_ZONES_QUERY_KEY] });
		},
	});
};
